import React, { useEffect, useState } from "react";
import {
  getMpSyncWatermarks,
  MpSyncWatermarkDto,
} from "api/MpSyncWatermarks";

const mpLabel = (mp: string) => {
  if (mp === "wildberries") return "WB";
  if (mp === "ozon") return "Ozon";
  if (mp === "1c") return "1С";
  return mp;
};

const kindLabel = (kind: string) => {
  if (kind === "reserved") return "резервы";
  if (kind === "warehouse") return "склад МП";
  if (kind === "remnant_1c") return "1С";
  if (kind === "send") return "отправка";
  return kind;
};

const formatWhen = (iso: string) => {
  const d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return "—";
  const agoMin = Math.round((Date.now() - d.getTime()) / 60000);
  const time = d.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
  if (agoMin < 1) return `${time} · только что`;
  if (agoMin < 60) return `${time} · ${agoMin} мин назад`;
  const agoH = Math.round(agoMin / 60);
  return `${time} · ${agoH} ч назад`;
};

/** Время последней выгрузки с МП (watermark), без опроса строк каталога. */
const MpSyncWatermarksStrip: React.FC = () => {
  const [rows, setRows] = useState<MpSyncWatermarkDto[]>([]);

  useEffect(() => {
    getMpSyncWatermarks()
      .then(setRows)
      .catch(() => setRows([]));
  }, []);

  if (!rows.length) {
    return (
      <div className="small text-muted mb-2">
        Выгрузки с МП: ещё нет данных (после ближайшего load reserved /
        warehouse)
      </div>
    );
  }

  const order = ["1c", "wildberries", "ozon"];
  const kindOrder = ["remnant_1c", "reserved", "warehouse", "send"];
  const sorted = [...rows].sort((a, b) => {
    const ai = order.indexOf(a.marketplace);
    const bi = order.indexOf(b.marketplace);
    if (ai !== bi) return (ai < 0 ? 99 : ai) - (bi < 0 ? 99 : bi);
    const aki = kindOrder.indexOf(a.kind);
    const bki = kindOrder.indexOf(b.kind);
    if (aki !== bki) return (aki < 0 ? 99 : aki) - (bki < 0 ? 99 : bki);
    return a.kind.localeCompare(b.kind);
  });

  return (
    <div
      className="small mb-2"
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "6px 14px",
        color: "#444",
      }}
    >
      <span style={{ fontWeight: 600 }}>Синхронизации:</span>
      {sorted.map((r) => (
        <span key={`${r.marketplace}:${r.kind}`}>
          {mpLabel(r.marketplace)} {kindLabel(r.kind)} —{" "}
          {formatWhen(r.asOf)}
          <span className="text-muted">
            {" "}
            (изм. {r.rowsChanged}/{r.rowsTotal})
          </span>
        </span>
      ))}
    </div>
  );
};

export default MpSyncWatermarksStrip;
